<template>
    <rkm-overlay>
        <rkm-layout-body title="Reagendamento por médico">
            <template v-slot:actions>
                <rkm-button @click="exit" color="danger">Sair</rkm-button>
            </template>

            <rkm-layout-content>
                <Form :id="id" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import Form from '@/components/regulacao/reagendamento-medico/Form'

export default {
    components: {Form},
    methods: {
        exit() {
            this.$router.push({name: 'regulacao-reagendamento-medico-index'})
        },
    },
    props: {id: {type: Number, required: true}},
}
</script>
